import type { ReactNode } from 'react'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import { shrinkableColumnSx } from '../Table/Table'

/** Keeps list filters on the page surface above the table's raised Paper. */
export function FilteredListLayout({ toolbar, children }: { toolbar?: ReactNode; children: ReactNode }) {
    return (
        <Box sx={{ ...shrinkableColumnSx, minWidth: 0, gap: 2 }}>
            {toolbar && (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        flexShrink: 0,
                        minWidth: 0,
                        gap: 1,
                    }}
                >
                    {toolbar}
                </Box>
            )}
            <Paper sx={{ ...shrinkableColumnSx, overflow: 'hidden' }}>{children}</Paper>
        </Box>
    )
}
